import { Account_Type } from "gen/coa/models_pb"
import { useEnumFilter } from "shared-ts/hooks/useFilter"

import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"
import { Accounting } from "lib/accounting"

export function useAccountTypeFilter({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<UseWebFilterProps<unknown>, "persistInUrl" | "initialSelectedOptions">
> = {}) {
  return useEnumFilter({
    key: "types",
    label: "Type",
    enumeration: Account_Type,
    labelExtractor: Accounting.accountTypeName,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })
}
